module.exports = { id: "wrench", url: "/build/app/img/symbols.svg#wrench", viewBox: "", toString: function() { return this.url; } };